module.exports = {
  appDirectory: "client-management",
  baseAPIUrl: "http://localhost:3000",
  clientId: "fffd5643-fb7b-472f-9623-6b28361b8af9",
  redirectUri: "http://localhost:3001/client-management"
};
